export function cleanStyles() {
    let $wrap = $(".has-sidebar");
    let $children = $wrap.find("p, span, ul, li, h1, h2, h3, h4, h5, h6");

    for (let i = 0; i < $children.length; i++) {
        $children.eq(i).removeAttr("style");
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/cleanStyles.js